import '@css/styles.scss';
import App from './app';

App.init();
